import { useCallback } from "react";
import {AccordionItem} from 'react-light-accordion';
import Table from "../../../common/table/table";
import { ShiftReportHoursStyle } from "./shiftReportHoursStyle";
import { shiftReportTableColumns } from './shiftReportTableColumns';
import styled from 'styled-components';

const AccordionItemContainer = styled.div`
    & .accordion-item .title {
        font-size: 1.5rem;
    }
`;

const TABLE_SUMMARY_ROWS = [
    {
        row: 'Total Labor Count',
        accessor: 'total_count',
    },
    {
        row: 'Labor Count Over/Under (Optimal)',
        accessor: 'optimal_count',
    },
    {
        row: 'Labor Cost Impact $',
        accessor: 'cost_impact',
    },
];

const ShiftReportAccordion = ({title, data}) => {
    const handleCellClick = useCallback((dailyId, hours) => {
        if (dailyId != null && hours > 0) {
            window.open(`/data_entry/daily/daily/edit/${dailyId}`, '_blank');
        }
    }, []);

    const columns = ['rig'].concat(data.rigs[0].shifts[0].data.map(item => item.date));

    const rigs = data.rigs.map(rig => {
        return rig.shifts.map(shift => ({
            name: rig.name,
            shift: shift.name,
            data: shift.data,
        }))
    }).flat();

    const tableBody = rigs.map((rig, index) => {
        return columns.reduce((prevColumn, currColumn) => {
            if (currColumn !== 'rig') {
                return ({ ...prevColumn, [currColumn]: rig.data.filter(item => item.date === currColumn)[0].count});
            }

            return (
                { 
                    ...prevColumn,
                    [currColumn]: `${rig.name} - ${rig.shift}`,
                    optimal_count: rig.data.filter(item => item.optimal_count !== 0)[0].optimal_count,
                    rig_id: rig.name,
                    shift: rig.shift,
                    isLastRig: index === rigs.length - 1,
                }
            );
        }, {});
    });

    const summaryRows = TABLE_SUMMARY_ROWS.map((row) => {
        return columns.reduce((prevColumn, currColumn) => {
            if (currColumn !== 'rig') {
                return ({ ...prevColumn, [currColumn]: data.summary.filter(item => item.date === currColumn)[0][row.accessor]});
            }

            return ({ 
                ...prevColumn, 
                [currColumn]: row.row,
                isSummary: true,
            });
        }, {});
    });

    return (
        <AccordionItemContainer>
            <AccordionItem className="card-header bg-primary" title={title}>
                <div className="p-4">
                    <ShiftReportHoursStyle>
                        <Table
                            columns={shiftReportTableColumns(columns, rigs, handleCellClick)}
                            data={[ ...tableBody, ...summaryRows ]}
                            exportOptions={{pdf: false, xlsx: true, csv: true}}
                            hasStickyHeader={true}
                            getExportFileName={() => "shift_report"}
                            isSortDisabled
                        />
                    </ShiftReportHoursStyle>
                </div>
            </AccordionItem>
        </AccordionItemContainer>
    );
}

export default ShiftReportAccordion;
